// Contact.jsx
import React, { useState } from 'react';
import '../../assets/css/student/home/GetInTouch.css';
import { IoClose } from 'react-icons/io5';

const Contact = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Form data submit ho gaya
    console.log('Form Submitted:', formData);
    alert('Thank you! Your message has been sent successfully.');
    
    // Form reset kar do
    setFormData({
      name: '',
      email: '',
      message: ''
    });
    
    // Sidebar close kar do
    onClose();
  };

  return (
    <>
      {/* Background Overlay */}
      <div 
        className={`git-overlay ${isOpen ? 'git-active' : ''}`}
        onClick={onClose}
      ></div>

      {/* Sidebar */}
      <div className={`git-sidebar ${isOpen ? 'git-open' : ''}`}>
        {/* Close Button */}
        <button className="git-close-btn" onClick={onClose}>
          <IoClose size={28} />
        </button>

        {/* Content */}
        <div className="git-content">
          {/* Header */}
          <div className="git-header">
            <h2 className="git-title">Get In Touch </h2>
            <p className="git-description">
              Give us a call or fill in the form below and we will contact you. 
              We endeavor to answer all inquiries within 24 hours on business days.
            </p>
          </div>

          {/* Form */}
          <form className="git-form" onSubmit={handleSubmit}>
            {/* Name Input */}
            <div className="git-form-group">
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
                className="git-form-input"
              />
            </div>

            {/* Email Input */}
            <div className="git-form-group">
              <input
                type="email"
                name="email"
                placeholder="Email address"
                value={formData.email}
                onChange={handleChange}
                required
                className="git-form-input"
              />
            </div>

            {/* Message Textarea */}
            <div className="git-form-group">
              <textarea
                name="message"
                placeholder="Message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="6"
                className="git-form-textarea"
              ></textarea>
            </div>

            {/* Submit Button */}
            <button type="submit" className="git-submit-btn">
              Submit
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Contact;